import Icon from 'assets/components/icon/Icon';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import { inputStyles } from 'assets/components/inputs/Input';
import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import useClaimFilters from 'module/claims/hooks/useClaimFilters';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useClaimProvider } from '../Claim.Hooks';
import { claimIndexRoute } from '../Claim.Index';
import { useClaimJobProvider } from '../ClaimJob.Hooks';
import { claimJobIndexRoute } from '../ClaimJob.Index';
import Theme from 'assets/themes/Theme.Common';

export function ClaimSwitchListButton() {
  const { pageRouter: claimPageRouter } = useClaimProvider();
  const { pageRouter: claimJobPageRouter } = useClaimJobProvider();
  const _history = useHistory();
  const _location = useLocation();

  const currentListType = useMemo(() => {
    if (_location.pathname.includes('claims/claim-job')) return 'claimJobs';
    return 'claims';
  }, [_location.pathname]);

  const { setClaimFilters, setClaimJobFilters } = useClaimFilters();

  return (
    <CheckInput
      style={{
        backgroundColor: Theme.Color.background,
        padding: `${Theme.Size.XS} ${Theme.Size.M}`,
        borderRadius: Theme.Size.M,
      }}
      name="listType"
      class={inputStyles.check.switch}
      icon={<Icon class="fas-switch" />}
      primaryState="claims"
      secondaryState="claimJobs"
      value={currentListType}
      label="state"
      onChange={({ listType }) => {
        if (listType === 'claims') {
          _history.push(createPathFromRoute(claimIndexRoute, {}, setClaimFilters(claimJobPageRouter.query.list)), {});
        } else if (listType === 'claimJobs') {
          _history.push(
            createPathFromRoute(claimJobIndexRoute, {}, setClaimJobFilters(claimPageRouter.query.list)),
            {}
          );
        }
      }}
    />
  );
}
